package ai.wagemix.net.models

import kotlinx.serialization.Serializable

interface WMJDUrlUpload {
    val url: String
    companion object
}

fun WMJDUrlUpload.Companion.kxs(url: String): KxsWMJDUrlUpload = KxsWMJDUrlUpload(url = url)
fun WMJDUrlUpload.toKxs(): KxsWMJDUrlUpload = this as? KxsWMJDUrlUpload ?: WMJDUrlUpload.kxs(url = url)

@Serializable
@ConsistentCopyVisibility
data class KxsWMJDUrlUpload internal constructor(override val url: String): WMJDUrlUpload